@if (items(); as bannerItems) {
  @if (bannerItems.length > 0) {
    <div class="header-banner">
      <div class="header-banner__content">
        <!-- Parte statica -->
        <div class="header-banner__static">
          <div class="header-banner__update">
            <div class="header-banner__update-label">{{ 'dottnet.headerBanner.lastUpdate' | translate }}</div>
            <div class="header-banner__update-date">{{ bannerItems[0].lastUpdate }}</div>
          </div>
          <div class="header-banner__separator">|</div>
        </div>

        <!-- Divider visibile solo su mobile -->
        <div class="header-banner__divider"></div>

        <!-- Parte scorrevole -->
        <div class="header-banner__ticker-wrapper">
          <div class="header-banner__ticker">
            <!-- Prima copia degli items -->
            @for (item of bannerItems; track $index) {
              <div class="header-banner__item">
                <div class="header-banner__item-type">{{ item.type }}:</div>
                @if (item.link) {
                  <a [routerLink]="item.link" class="header-banner__item-title">{{ item.title }}</a>
                } @else {
                  <div class="header-banner__item-title">{{ item.title }}</div>
                }
              </div>
              <div class="header-banner__item-separator">|</div>
            }
            <!-- Seconda copia per loop continuo -->
            @for (item of bannerItems; track $index) {
              <div class="header-banner__item">
                <div class="header-banner__item-type">{{ item.type }}:</div>
                @if (item.link) {
                  <a [routerLink]="item.link" class="header-banner__item-title">{{ item.title }}</a>
                } @else {
                  <div class="header-banner__item-title">{{ item.title }}</div>
                }
              </div>
              <div class="header-banner__item-separator">|</div>
            }
          </div>
        </div>
      </div>
    </div>
  }
}
